<template>
  <div>
    <div class="container">
      <div v-if="show.list && !propNovo && !propSegundaVia && !procedimento && !propNumeroPedidoPossueOrdemServico"
           class="row">
        <div class="col">
          <ordens-servico-search :prop-registro-id="propRegistroId"
                                 @results="getResults" />
        </div>
        <div class="col-4 text-right">
          <button class="btn btn-sm btn-primary mt-3"
                  @click="viewOrdemServico().add()">
            <icon-svg icon="add"
                      class="icon--xs icons--white" />
            Adicionar Nova Ordem de Serviço
          </button>
        </div>
      </div>
      <ordens-servico-list v-if="show.list && !propNovo && !propSegundaVia && !procedimento && !propNumeroPedidoPossueOrdemServico"
                           :prop-ordens-servico="ordensServico"
                           :prop-os="idOrdemServico"
                           :pode-enviar-selos="podeEnviarSelos"
                           @onEdit="viewOrdemServico().edit($event)"
                           @onDelete="ordemServico().deleteOs($event)"
                           @imprimirRecibo="imprimirRecibo"
                           @enviarSelo="enviarSeloManualmenteTJ" />
    </div>

    <OrdemServico v-if="(show.form.add || propNovo || propSegundaVia || procedimento) || show.form.edit || propNumeroPedidoPossueOrdemServico"
                  :prop-ordem-servico="formEditOrdemServico"
                  :prop-novo="propNovo"
                  :prop-solicitante="dadosSolicitante"
                  :prop-registro-id="propRegistroId"
                  :prop-registro="propRegistro"
                  :prop-tipo="propTipo"
                  :prop-gerar-cpf="propGerarCpf"
                  :prop-gemeos="propGemeos"
                  :prop-novo-procedimento="!!procedimento"
                  :prop-data="propData"
                  :prop-pedido-pendente="pedidoPendente"
                  :prop-pedido-p13="propPedidoP13"
                  @solicitarImpressao="$emit('solicitarImpressao')"
                  @onBack="viewOrdemServico().back()" />

    <ModalImpressao :url="pdfUrl"
                    @close="() => pdfUrl = ''" />

    <b-modal v-if="show.select"
             id="select-os-recibo"
             ref="select-os-recibo"
             visible
             hide-header
             hide-footer
             size="xs"
             @hide="show.select = false, selectSelo = null">
      <h6 class="mb-3">
        Escolha um selo para utilizar na Impressão do recibo
      </h6>
      <v-select v-if="optionsSelos.length > 0"
                v-model="selectSelo"
                v-validate="'required'"
                :options="optionsSelos"
                :class="{'is-invalid': errors.has('optionsSeloRecibo')}"
                class="form-control form-control-sm"
                name="optionsSeloRecibo"
                label="num_selo">
        <template #selected-option="{ tipo_ato, num_selo }">
          Tipo: {{ tipo_ato }} - Selo: {{ num_selo }}
        </template>

        <template #option="{ tipo_ato, num_selo }">
          Tipo: {{ tipo_ato }} - Selo: {{ num_selo }}
        </template>
      </v-select>
      <small v-if="errors.has('optionsSeloRecibo')"
             class="text-danger">{{ errors.first('optionsSeloRecibo') }}</small>
      <hr>
      <div class="text-right mt-2">
        <button class="btn btn-sm"
                @click="show.select = false, selectSelo = null">
          Voltar
        </button>
        <button class="btn btn-sm btn-secondary"
                @click="selectedSelo">
          Continuar
        </button>
      </div>
    </b-modal>

    <b-modal v-if="propNumeroPedidoPossueOrdemServico"
             id="aviso-numero-pedido-possui-ordem-servico"
             size="md"
             hide-header
             hide-footer
             no-close-on-backdrop
             no-close-on-esc
             centered>
      <p class="mt-3">
        Já foi criada a OS nº <strong style="font-size: 1.2rem;">{{ propPedidoPendente.numPedidoPossueOrdemServico.numero }}</strong> para o pedido nº <strong style="font-size: 1.2rem;">{{ propPedidoPendente.pedido_certidao_id }}</strong>
      </p>
      <div class="d-flex justify-content-end mt-4">
        <b-button
          variant="primary"
          class="btn-numero-pedido-possui-ordem-servico"
          @click="$bvModal.hide('aviso-numero-pedido-possui-ordem-servico')">
          OK
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>

  /* entities */
  import { useCaseOrdemServico } from "@/entities/OrdemServico/useCaseOrdemServico.js"
  /* components */
  import OrdensServicoSearch from "@/components/SofiaRei/Resumo/OrdensServico/OrdensServicoSearch"
  import OrdensServicoList from "@/components/SofiaRei/Resumo/OrdensServico/OrdensServicoList"
  import OrdemServico from '@/components/SofiaRei/Resumo/OrdensServico/OrdemServico'
  import ModalImpressao from "@/components/ModalImpressao/ModalImpressao"


  /* services */
  import SelosService from "@/services/Registros/SelosService"
  import CustasService from "@/services/Registros/CustasService"
  import OrdensServicoService from "@/services/Registros/OrdensServicoService"
  import RecibosService from "@/services/Registros/RecibosService"
  import ProcedimentoService from "@/services/ProcedimentoService"

  /* constants */
  import custas from '@/constants/custas'
  import Swal from 'sweetalert2'
  import {mapGetters} from "vuex"
  import moment from "moment"

  import { CriarSelo } from "../../../common/selo"

  /* utils */
  import { displayQuestion as displayQuestionConfirm } from '@/utils/displayQuestion.js'

  export default {
    name: "ResumoOrdensServicos",
    components: {
      OrdensServicoSearch,
      OrdensServicoList,
      OrdemServico,
      ModalImpressao
    },

    props: {
      propPedidoP13: {type: Object, default: () => {}},
      propPedidoPendente: {type: Object, default: () => {}},
      propRegistroId: { type: Number, default: () => { return null }},
      propTipo: {type: String, default: () => { return null }},
      propRegistro: { type: Object, default: () => { return {} }},
      propData: { type: Object, default: () => { return {}}},
      propSolicitante: { type: Object, default: () => { return {}}},
      propNovo: { type: Boolean, default: false },
      propGemeos: { type: Array, default: () => ([])},
      propGerarCpf: { type: Boolean, default: false },
      propOsAutuacao: { type: Boolean, default: false },
      propOs: { type: Number, default: null},
      propSegundaVia: { type: Boolean, default: false},
      propNumeroPedidoPossueOrdemServico: { type: Boolean, default: false}
    },

    data () {
      return {
        custaSelo: null,
        urlRecibo: null,
        ordensServico: [],
        optionsSelos: [],
        selectSelo: null,
        custas: [],
        show: {
          list: true,
          form: {
            add: false,
            edit: false
          },
          recibo: false,
          select: false
        },
        formEditOrdemServico: {},
        ordemGemeo: 0,
        idOrdemServico: null,
        reset: false,
        pdfUrl: '',
        pedidoPendente: {},
      }
    },

    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId',
        cartorioObj: 'auth/getCartorioObj',
        procedimento: 'procedimento/getProcedimento',
        solicitanteProcedimento: 'procedimento/getRequerente'
      }),
      dadosSolicitante () {
        let length = this.ordensServico.length
        const solicitante = {
          cpf: null,
          nome: null
        }

        if (!!this.solicitanteProcedimento && !!this.procedimento) {
          const { nome, cpf } = this.solicitanteProcedimento

          Object.assign(solicitante, { cpf_solicitante: cpf, nome_solicitante: nome })
        } else if (!!this.ordensServico[length - 1]) {
          // pegando solicitante da ultima O.S
          const { cpf_solicitante, nome_solicitante } = this.ordensServico[length - 1]
          Object.assign(solicitante, { cpf_solicitante, nome_solicitante })
        } else {
          if (['D', 'C', 'CR'].indexOf(this.propData.registro.tipo_registro) !== -1)  {
            if (!!this.propData.registro.pessoas[0]) {
              //pegando dados do primeiro Conjuge como solicitante"
              const { cpf, nome_antigo } = this.propData.registro.pessoas[0]
              Object.assign(solicitante, { cpf_solicitante: cpf, nome_solicitante: nome_antigo })
            }
          } else {
            if (!!this.propData.registro.partes && this.propData.registro.partes[0] && this.propData.registro.partes[0].pessoa) {
              //pegar solicitante cadastrado em "partes/declarante"
              const { pessoa: { cpf, nome }} = this.propData.registro.partes[0]
              Object.assign(solicitante, { cpf_solicitante: cpf, nome_solicitante: nome })
            }
          }
        }

        return solicitante
      }
    },

    watch: {
      propRegistro () {
        this.init()
      },
      ordensServico (novoValor) {
        if (novoValor.length && this.propNumeroPedidoPossueOrdemServico) {
          this.formEditOrdemServico = novoValor.find(
            os => os.numero === this.propPedidoPendente.numPedidoPossueOrdemServico.numero
          ) || {}
        }
      }
    },

    mounted () {
      this.init()

      if (this.propOs) this.idOrdemServico = this.propOs
    },

    methods: {
      async init () {
        const os = this.ordemServico()
        os.list()
        await this.getCustas()
        
        if (this.propPedidoPendente) {
          this.pedidoPendente = this.propPedidoPendente
        }

      },
      async getCustas () {
        loader({ active: true })
        const custas = await CustasService.getCustas({
          cartorio_id: this.$store.state.auth.cartorio_id,
          perPage: 100,
          os: 1,
          ativo: true
        })
        this.custas = custas.data
        loader({ active: false })
      },

      viewOrdemServico () {
        const resetShow = () => {
          this.show.list = false
          this.show.form.add = false
          this.show.form.edit = false
          this.$emit('onNewOs', false)
        }

        const add = () => {
          resetShow()
          this.show.form.add = true
        }

        const edit = (objOS) => {
          Object.assign(this.formEditOrdemServico, objOS.os)
          resetShow()
          this.show.form.edit = true
        }

        const back = async (reload = true) => {
          this.idOrdemServico = null

          if (this.propGemeos && this.propGemeos.length) {
            if (this.propGemeos.length - 1 !== this.ordemGemeo) {
              return
            } else {
              setTimeout(() => {
                if (reload) {
                  this.init()
                }
                resetShow()

                this.ordemServico().list()

                this.show.list = true

                loader({ active: false })

                setTimeout(() =>  {
                  const numOrdemServico = document.getElementById('numero_ordem_servico')

                  if (numOrdemServico) numOrdemServico.focus()
                  
                }, 300)
              }, 1000 * (this.ordemGemeo > 5 ? 5 : this.ordemGemeo + 1))
            }
            this.ordensServico = await OrdensServicoService.getOSByResgitroId(this.propRegistroId)
          } else {
            if (reload) {
              this.init()
            }
            resetShow()

            this.ordemServico().list()

            this.show.list = true

            // eslint-disable-next-line no-unused-vars
            let os = this.propOs

            os = null

            loader({ active: false })

            setTimeout(() =>  {
              const numOrdemServico = document.getElementById('numero_ordem_servico')

              if (numOrdemServico) numOrdemServico.focus()
            }, 300)
          }
        }

        return { add, edit, back }
      },
      // pega qtd de selos
      selosItem (os) {
        let selosQtd = 0

        os.itens.map(ordemServico => {
          if (ordemServico.seloItemOs && ordemServico.seloItemOs.length > 0 && !ordemServico.flag_cancelado) {
            ordemServico.seloItemOs.map(selo => {
              if (!!selo) {
                selosQtd++
              }
            })
          }
        })

        return selosQtd
      },

      ordemServico () {
        const list = async () => {
          loader({ active: true })
          this.ordensServico = await OrdensServicoService.getOSByResgitroId(this.propRegistroId)
          this.$emit("onUpdateOrdemServico", this.ordensServico)
          loader({ active: false })
        }

        const newOs = async (ordemServico, papelSegurancaCusta) => {
          loader({ text: '', active: true })
          const ordemServicoSelo = await this.selos(ordemServico, papelSegurancaCusta).salvar()

          Object.assign(ordemServico, ordemServicoSelo)
          // await consomePapel(papelSegurancaCusta)

          if (this.propSegundaVia) {
            this.$emit('resetSegundaVia')
          }

          if (!!this.procedimento) {
            try {
              const obj = {
                ...this.procedimento,
                ordem_servico_id: ordemServico.ordem_servico_id
              }

              await ProcedimentoService.atualizarProcedimento(obj, obj.procedimento_id)

              this.$store.dispatch('procedimento/updateProcedimento', null)
              this.$store.dispatch('procedimento/updateRequerente', {})
            } catch (error) {
              const message = getErrors(error)

              displayMessage('error', 'Erro!', message.message)
            } finally {
              loader({ text: '', active: false })
            }
          }
        }

        const deleteOs = async (objOs) => {
          const selos = this.selosItem(objOs.os)

          let obj = {
            title: `Deseja excluir Ordem de Serviço?`,
            showCancelButton: true,
            reverseButtons: true,
            // comentando para caso mudem de ideia
            /*input: 'checkbox',
            inputValue: 1,
            inputPlaceholder: 'Excluir selos no TJ',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Excluir'*/
          }

          if (selos > 0) {
            let type = 'question'
            let confirmButtonText = 'Visualizar OS'
            if (this.show.form.edit) {
              type = 'warning'
              confirmButtonText = 'Continuar'
            }

            objSwal[type].title = 'Atenção!'
            objSwal[type].text = 'Esta OS possui selos. Para excluir a OS, verifique os itens dentro dela.'
            objSwal[type].confirmButtonText = confirmButtonText
            Swal.fire(objSwal[type]).then(status => {
              if (status.value) {
                // codigo que levará para visualização da OS
                this.viewOrdemServico().edit(objOs)
              }
            })
            return
          } else {
            // comentando para caso mudem de ideia
            /*console.log('nao tem selos')
            obj.inputValue = 0
            delete obj.input*/
          }

          const response = await Swal.fire(obj)

          if (response.value != undefined) {
            try {
              if (response.value && selos.length) {
                loader({ text: 'Excluindo OS...', active: true })

                const response = () => {
                  return new Promise((resolve, reject) => {
                    const selosPromise = this.selos(objOs.os).excluir()

                    Promise.all(selosPromise).then((res) => {

                      if (res.length > 0) {
                        resolve()
                      } else {
                        reject()
                      }
                    }).catch(() => {
                      objSwal.error.title = "Erro ao excluir selo no TJ. Tente novamente."
                      objSwal.error.text = ""
                      reject()
                    })

                  })
                }

                response().then(async ()=> {
                  // Não excluimos a O.S, apenas a cancelamos
                  objOs.os = {
                    ...objOs.os,
                    cancelada: true,
                    data_cancelamento: moment().format('YYYY-MM-DD')
                  }

                  const payload = objOs.os

                  // Verificamos se a OS tem algum selo
                  payload.existeSelo = !!payload.itens.find(item => item.seloItemOs.length)

                  const res = await OrdensServicoService.updateOS(payload, payload.ordem_servico_id)

                  if (res) {
                    this.ordensServico.splice(objOs.index, 1)
                  }
                  loader({ active: false })
                }).catch(() => {
                  if (objSwal.error.title != "Erro ao excluir selo no TJ. Tente novamente.") {
                    objSwal.error.title = "Sem selos para excluir"
                    objSwal.error.text = "Caso queira excluir apenas a O.S. desmarque a opção 'Excluir selos no TJ'"
                  }

                  this.displayError(objSwal.error.title, objSwal.error.text)
                  loader({ active: false })
                })
              } else {
                loader({ text: 'Excluindo OS...', active: true })

                // Não excluimos a O.S, apenas a cancelamos
                objOs.os = {
                  ...objOs.os,
                  cancelada: true,
                  data_cancelamento: moment().format('YYYY-MM-DD')
                }

                const payload = objOs.os

                // Verificamos se a OS tem algum selo
                payload.existeSelo = !!payload.itens.find(item => item.seloItemOs.length)

                const res = await OrdensServicoService.updateOS(payload, payload.ordem_servico_id)
                if (res) {
                  this.ordensServico.splice(objOs.index, 1)
                }
                loader({ active: false })
              }

            } catch (e) {
              objSwal.error.title = `Erro ao excluir OS ${objOs.os.ordem_servico_id}`
              objSwal.error.text = e.response.data.message
              Swal.fire(objSwal.error)
            } finally {
              this.$emit("onUpdateOrdemServico", this.ordensServico)
              voltar(objOs.os)
            }
          }
        }

        const voltar = (ordemServico) => {
          if (ordemServico) {
            if (!ordemServico.ordem_servico_id) {
              !(this.ordensServico.find(ordemServico)) && this.ordensServico.push(ordemServico)
              this.viewOrdemServico().back(false)
            } else {
              this.viewOrdemServico().back()
            }
          }
        }

        return { list, newOs, deleteOs, voltar}
      },

      async enviarSeloManualmenteTJ (ordemDeServico) {
        try {
          const questionText = 'Confirmar o envio manual dos selos da OS ' + ordemDeServico.numero + '?'
          const response = await displayQuestionConfirm(null, questionText, 'Sim', 'Não', null, '#074f7f', '#8b0000')

          if (!response) return

          // Extrai os selos
          let selos = (ordemDeServico.itens || [])
            .flatMap(item => item.seloItemOs || [])
            .map(item => item.selo)
            .filter(selo => selo && selo.envio_tj === 0)

          let enviados = 0
          let falhas = 0
          let resultados = []

          // Envio individual
          for (let i = 0; i < selos.length; i++) {
            let selo = selos[i]

            try {
              await SelosService.enviarNumeroSeloApi(selo.num_selo)

              enviados++

              resultados.push({
                selo: selo.num_selo,
                status: 'sucesso'
              })
            } catch (error) {
              falhas++

              let mensagemErro = 'Erro ao enviar selo'

              if (error && error.response && error.response.data && error.response.data.mensagem) {
                mensagemErro = error.response.data.mensagem
              } else if (error && error.response && error.response.data && error.response.data.error) {
                mensagemErro = error.response.data.error
              } else if (error && error.message) {
                mensagemErro = error.message
              }

              resultados.push({
                selo: selo.num_selo,
                status: 'erro',
                erro: mensagemErro
              })
            }
          }

          // Todos os selos já enviados
          if (enviados === 0 && falhas === 0) {
            displayMessage('success', null, 'Todos os selos já foram enviados ao TJ.', { confirmButtonText: 'Continuar' })

            this.ordemServico().list()
            return
          }

          // Sucesso total
          if (falhas === 0) {
            displayMessage('success', null, 'Selos enviados com sucesso!', { confirmButtonText: 'Continuar' })

            this.ordemServico().list()
            return
          }

          // Erro parcial
          let mensagens = resultados
            .filter(item => item.status === 'erro')
            .map(item => '• Selo ' + item.selo + ': ' + item.erro)
            .join('<br>')

          displayMessage('success', null, mensagens, {useHtml: true, confirmButtonText: 'Continuar'})
          this.ordemServico().list()

        } catch (error) {
          let mensagem = 'Ocorreu um erro ao enviar os selos para o TJ.'

          if (error && error.response && error.response.data && error.response.data.mensagem) {
            mensagem = error.response.data.mensagem
          } else if (error && error.response && error.response.data && error.response.data.message) {
            mensagem = error.response.data.message
          } else if (error && error.message) {
            mensagem = error.message
          }

          displayMessage('error', null, mensagem)
        }
      },
      podeEnviarSelos (ordemDeServico) {
        const selos = (ordemDeServico.itens || [])
          .flatMap(item => item.seloItemOs || [])
          .map(seloItem => seloItem.selo)
          .filter(Boolean)

        if (selos.length === 0) {
          return false
        }

        return selos.some(selo => selo.envio_tj === 0)
      },

      selos (ordemServico, papelSegurancaCusta) {
        const salvar = async () => {
          let tipoRegistro = null
          if (!!this.propData && !!this.propRegistroId) {
            tipoRegistro = this.propData.registro.tipo_registro
          }

          const { selosList } = await CriarSelo(ordemServico, papelSegurancaCusta, this.cartorioObj, tipoRegistro)

          ordemServico = await OrdensServicoService.showOS(ordemServico.ordem_servico_id)
          voltar(ordemServico)

          try {
            if (selosList.length) {
              this.displaySucess(`OS ${ordemServico.numero} e selos foram gerados com sucesso!`, "", ordemServico).then(() => {
                if (this.propOsAutuacao) {
                  this.$emit('gerarAutuacao')
                  voltar(ordemServico)
                }
              })
            } else {
              this.displaySucess(`OS ${ordemServico.numero} gerada com sucesso!`, "", ordemServico).then(() => {
                if (this.propOsAutuacao) {
                  this.$emit('gerarAutuacao')
                  voltar(ordemServico)
                }
              })
            }
          } catch (error) {
            this.displayError('Erro ao gerar O.S', error)
          }
        }

        const saveAtoSelo = async (item, ato) => {
          /* criando o corpo do objeto que será enviado para a criacao do selo */
          const objData = {
            registro_id: ordemServico.registro_id,
            ordem_servico_item_id: item.ordem_servico_item_id,
            cpf: process.env.NODE_ENV === 'production' ? ordemServico.cpf_solicitante : '40300169876', // hmlg > CPF VENDRA "40300169876"
            natureza: item.custa.tipo === 'ATOS_NOTARIAIS' ? 1 : 2,
            ato: ato,
            cns: process.env.NODE_ENV === 'production' ? this.$store.state.auth.cartorioObj.cns : '115204' //  hmlg > CNS VENDRA 115204
          }

          try {
            const selo = await SelosService.storeSelo(objData)

            if (selo) {
              selosList.push(selo)
              if (!item.seloItemOs) item.seloItemOs = []

              item.seloItemOs.push({
                selo_id: selo.selo_id,
                ordem_servico_item_id: item.ordem_servico_item_id,
                selo: { ...selo }
              })
            }
            this.displaySucess('O.S. gerada com sucesso!', `O.S. ${ordemServico.numero}`, ordemServico).then(() => {
              if (this.propOsAutuacao) {
                this.$emit('gerarAutuacao')
              }
            })

            this.viewOrdemServico().back(false)
          } catch (e) {
            let message = null
            if (e.response && e.response.data && e.response.data.message && e.response.data.message.errors.length) {
              message =  e.response.data.message.errors[0].replace('=>', `CNS: ${objData.cns}`)
            }
            this.displaySucess(`Houve um erro ao gerar selo, porém a O.S. ${ordemServico.numero} foi gerada com sucesso!`, message, ordemServico).then(() => {
              if (this.propOsAutuacao) {
                this.$emit('gerarAutuacao')
              }
            })

            this.viewOrdemServico().back()
          }
        }

        const chooseCusta = (codigoCusta) => {
          if (custas.duplos.indexOf(codigoCusta) !== -1) {
            return custas[this.propTipo][codigoCusta]
          } else if (custas.todos[codigoCusta]) {
            return custas.todos[codigoCusta]
          } else {
            return custas[this.propTipo][codigoCusta]
          }
        }

        const excluir = () => {
          try {
            const selosExcluidos = []

            ordemServico.itens && ordemServico.itens.map((item) => {
              item.seloItemOs && item.seloItemOs.map((seloItem) => {
                // comentando provisoriamente
                // if (seloItem.selo.qrcode) {
                loader({ text: 'Excluindo selos no TJ...', active: true})
                const responseSelo = SelosService.excluirSelo(seloItem.selo.selo_id)
                selosExcluidos.push(responseSelo)
                // }
              })
            })

            return selosExcluidos
          } catch (e) {
            console.error(e)
            loader({ text: '', active: false})
          }
        }

        const voltar = (ordemServico) => {
          if (ordemServico) {
            if (!ordemServico.ordem_servico_id) {
              !(this.ordensServico.find(ordemServico)) && this.ordensServico.push(ordemServico)
              this.viewOrdemServico().back(false)
            } else {
              this.viewOrdemServico().back()
            }
          }
        }

        return { salvar, excluir, voltar }
      },
      calcEmolumentos (custa) {
        const realToCents = (real) => {
          if (typeof real == `string`) {
            let replaces = ["R", "$", ".", ","]
            let cents = []
            for (let key in real) {
              if (replaces.indexOf(real[key]) === -1) {
                cents.push(real[key])
              }
            }
            real = cents.join('')
            return parseInt(real)
          } else {
            return real
          }
        }

        const convertCents = (cents) => {
          return (realToCents(cents) / 100).toLocaleString("pt-BR", {style: "currency", currency: "brl"})
        }

        const destinatarios = {
          ao_oficial: "Oficial",
          iss: "ISSQN",
          ao_ipesp: "IPESP",
          total: "Total"
        }

        const emolumentos = {}

        custa.custa.itens.forEach(subItem => {
          emolumentos[subItem.destino] = {
            destino: subItem.destino,
            valor: (emolumentos[subItem.destino] && emolumentos[subItem.destino].valor || 0) + subItem.valor,
            label: destinatarios[subItem.destino]
          }

          emolumentos[`total`] = {
            destino: `total`,
            valor: emolumentos[`total`] && emolumentos[`total`].valor ? emolumentos[`total`].valor + subItem.valor : subItem.valor ,
            label: destinatarios[`total`]
          }
        })

        // Object.keys(emolumentos).forEach(key => {
        //  emolumentos[key].valor = convertCents(emolumentos[key].valor)
        // })

        return emolumentos
      },
      selectRecibo (custa) {
        this.loadSelo(custa)
        if (this.optionsSelos.length > 1) {
          this.show.select = true
        } else {
          this.selectSelo = this.optionsSelos[0]
          this.selectedSelo(custa)
        }
      },
      async imprimir (os) {
        try {
          this.show.select = false
          loader({ active: true, text: `Gerando recibo...` })

          const switchType = {
            obito: RecibosService.reciboObito,
            nascimento: RecibosService.reciboNascimento,
            habilitacao: RecibosService.reciboCasamento,
            casamento: RecibosService.reciboCasamento
          }

          const params = {
            registro: this.propRegistro,
            data: this.propData,
            os: Object.assign({}, { ...os }),
            custa: Object.assign({}, { ...this.custaSelo }),
            cartorio: this.cartorioObj,
            emolumentos: this.calcEmolumentos(Object.assign({}, { ...this.custaSelo })),
            selo: this.selectSelo
          }

          const url = await switchType[this.propTipo](params)

          this.urlRecibo = url
          this.show.recibo = true
        } catch (e) {
          this.displayError('Erro ao gerar recibo', e)
        } finally {
          loader({ active: false })
        }

        this.$emit('imprimir', os)
      },
      getResults (os) {
        this.ordensServico = os
      },
      displaySucess (title, text, os) {
        loader({ active: false })

        objSwal.success.title = title
        objSwal.success.text = text
        objSwal.success.html = ''

        setTimeout(() => {
          const btnConfirm = document.querySelector('.swal2-confirm')

          if (btnConfirm) btnConfirm.focus()
        }, 300)

        return Swal.fire(objSwal.success).then(() => {
          this.displayQuestion('Deseja Imprimir o Recibo de Serviço ?').then((resp) => {
            if (resp.value) {
              this.imprimirRecibo(os, true)
            }
          })
        })
      },
      displayQuestion (title, text) {
        objSwal.question.title = title
        objSwal.question.text = text
        objSwal.question.html = ""
        objSwal.question.cancelButtonText = 'Não'
        objSwal.question.confirmButtonText = 'Sim'

        return Swal.fire(objSwal.question).then((resp) => {
          const numOrdemServico = document.getElementById('numero_ordem_servico')
          if (numOrdemServico) numOrdemServico.focus()
          return resp
        })
      },
      displayError (title, text) {
        loader({ active: false })

        objSwal.error.title = title
        objSwal.error.text = text
        objSwal.error.html = ''

        setTimeout(() => {
          const btnConfirm = document.querySelector('.swal2-confirm')

          if (btnConfirm) btnConfirm.focus()
        }, 300)

        return Swal.fire(objSwal.error).then(() => {
          const numOrdemServico = document.getElementById('numero_ordem_servico')

          if (numOrdemServico) numOrdemServico.focus()
        })
      },
      loadSelo (custa) {
        const selos = []

        if (!custa) {
          return
        }

        custa.seloItemOs.map(item => {
          selos.push(item.selo)
        })

        this.optionsSelos = selos
      },

      selectedSelo (custaDireta) {
        const exec = () => {
          let custa = null
          let ordemServico = null

          if (this.ordensServico.length > 0 && this.selectSelo) {
            this.ordensServico.forEach(os => {
              os.itens.forEach(item => {
                return item.seloItemOs.find(itemOs => {
                  if (itemOs.selo.num_selo == this.selectSelo.num_selo) {
                    custa = item
                    ordemServico = os
                    return true
                  } else {
                    return false
                  }
                })
              })
            })

            this.custaSelo = custa

            this.imprimir(ordemServico)
          } else {
            this.ordensServico.forEach(os => {
              os.itens.forEach(item => {
                if (item.custa_id == custaDireta.custa_id) {
                  ordemServico = os
                }
              })
            })
            this.custaSelo = custaDireta
            this.imprimir(ordemServico)
          }
        }

        this.$validator.validate(`optionsSeloRecibo`).then(res => {
          if (res) {
            exec()
          }
        }).catch(() => {
          exec()
        })
      },

      openPdf (url) {
        window.open(url)
      },
      async imprimirRecibo (ordemServico) {
        try {
          loader({ active: true, text: `Gerando recibo...` })
          const url = await new useCaseOrdemServico(ordemServico).imprimirRecibo(this.propTipo, this.propRegistro,this.propData) 
          this.pdfUrl = url         
        } catch (e) {
          this.displayError('Erro ao gerar recibo', e)
        } finally {
          loader({ active: false })
        }
        this.$emit('imprimir', ordemServico)
      },
      getSelo (os) {
        let selo = null

        for (const item of os.itens) {
          if (!item.seloItemOs) continue
          selo = item.seloItemOs.find(selo => !!selo)

          if (selo) break
        }


        return selo ? selo.selo : null
      },
      getCusta (os) {
        let custas = []

        os.itens.forEach(item => {
          custas.push(item)

        })

        return custas
      },
      getEmolumentos (itensOS = []) {
        let emolumentos = []
        let valor = null

        itensOS.forEach(item => {
          const { custa, averbacao, quantidade } = item

          custa.itens.forEach(custaItem => {
            const emolumentoIndex = emolumentos.findIndex(emolumento => emolumento.destino === custaItem.destino)

            if (averbacao > 0) {
              const custaAverbacaoItem = this.custas.find(custaIss => custaIss.codigo === 12)
              const destinatario = custaAverbacaoItem.itens.filter(custa => custa.destino == custaItem.destino)
              valor = (custaItem.valor * quantidade) + (destinatario[0].valor * averbacao)
            } else {
              valor = (custaItem.valor * quantidade)
            }
            
            if (emolumentoIndex >= 0) {
              emolumentos[emolumentoIndex].valor += item.valor > 0 ? valor : 0
            } else {
              emolumentos.push({
                destino: custaItem.destino,
                valor: item.valor > 0 ? valor : 0
              })
            }
          })  
        })

        emolumentos.push({
          destino: 'total',
          valor: emolumentos.map((e) => e.valor).reduce((a, b) => a + b, 0)
        })

        return emolumentos
      }
    }
  }
</script>

<style lang="scss">
  @import "src/scss/_utilities/exports";

  .ResumoOrdensServicos {
    @media only screen and (max-width: 1600px) {
      &_modal {
        height: 33em !important;
        overflow: auto !important;
      }
    }

    @media only screen and (min-width: 1650px) {
      &_modal {
        height: 40em !important;
        overflow: auto !important;
      }
    }
  }

  .btn-numero-pedido-possui-ordem-servico {
    padding: 0.2rem 2rem;
    border-radius: 4px;
    font-size: 1rem;
  }
</style>
